import { Spinner } from "reactstrap";
import useLoading from "src/hooks/useLoading";

import styles from "./globalLoader.module.scss";

const GlobalLoader = () => {
  const { isLoading } = useLoading();

  return (
    <div
      className={`${styles["dd-page-loader"]} ${isLoading ? "" : "d-none"}`}
      data-testid="loader-component"
    >
      <div className="text-center">
        <Spinner color="danger"></Spinner>
      </div>
    </div>
  );
};

export default GlobalLoader;
